import { useAppSelector, useAppDispatch } from 'Store/selectors'
import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { GetVisitRequestById, GetVisitRequestPagedFilter } from '../../Actions/action'
import VisitDispatchData from './VisitDispatchData'
import CircularProgressbar from 'Components/CircularProgressbar'
import Icon from 'Components/Icon'
import VisitsPaths from 'Application/Visits/Constants/VisitsPaths'
import { useTranslation } from 'react-i18next'

const DispatchPage = () => {
  const [t] = useTranslation()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const { Id } = useParams<{ Id: string }>()
  const DispatchId = Number(Id)

  const { selectedItem: data, loading } = useAppSelector(s => s.visits.dispatchRequestList)

  useEffect(() => {
    dispatch(GetVisitRequestById(DispatchId))
  }, [dispatch])

  if (loading) {
    return (
      <div className="flex items-center justify-center grow">
        <CircularProgressbar />
      </div>
    )
  }

  if (!data) {
    return (
      <>
        <div className="flex justify-between items-center h-16 px-6 shrink-0">
          <div className="flex items-center gap-2">
            <div onClick={() => navigate(-1)}>
              <Icon name="arrow-right" className="w-6 h-6 text-gray-700 cursor-pointer" />
            </div>
            <div className="text-lg font-bold pl-2">{t('DISPATCH_DETAIL')}</div>
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      <div className="flex justify-between items-center h-16 px-6 shrink-0">
        <div className="flex items-center gap-2">
          <div onClick={() => navigate(-1)}>
            <Icon name="arrow-right" className="w-6 h-6 text-gray-700 cursor-pointer" />
          </div>
          <div className="text-lg font-bold pl-2">{t('DISPATCH_DETAIL')}</div>
        </div>
      </div>

      <div className="flex flex-col grow overflow-auto">
        <div className="overflow-auto px-6 pb-6">
          <VisitDispatchData data={data}  />
        </div>
      </div>
    </>
  )
}

export default DispatchPage
